import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e57a2c5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loginTabs" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "active" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "line"
}
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = { class: "Code login-common-style" }
const _hoisted_8 = { class: "iphone" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "validation2"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "codeError" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "validation" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_16 = {
  key: 1,
  class: "min"
}
const _hoisted_17 = { class: "validation vali2" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_19 = { class: "channelCode vali3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_21 = { class: "clause service" }
const _hoisted_22 = {
  key: 1,
  class: "login-mask"
}

import { onMounted, ref, reactive, computed, watch } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { ResultCommon } from "@/types/common";
import {
  checkRegisterImageCode,
  sendIphoneCode,
  getSendCode,
  registerEmail,
  registerIphone,
  sendEmailCode,
} from "@/api/register";

import store from "@/store";
import i18n from "@/lang";
import { isEmail } from "@/utils/index";
import router from "@/router";
import { getCookie } from "@/utils/cookies";


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
  visibleRe: {
    type: Boolean,
    default: false,
  },
},
  emits: ["gotoLogin", "gotoRegister"],
  setup(__props, { emit }) {

const props = __props

const language = computed(() => store.state.appLanguage);
const isShowLogin = computed(() => {
  return store.state.registerDialog || store.state.isMobile;
});

const sendCodeText = ref("");


const isMobile = store.state.isMobile;

const registerFormMoblile = reactive({
  number: "",
  iphoneCode: "",
  inputCode: "",
  password: "",
  invitationCode: "",
  channelNos: "",
});
const disabledInvitationCode = ref(false);
const initInvitationCode = () => {
  let cid = getCookie("cid");
  registerFormMoblile.channelNos = getCookie("cid_h") || "";
  if (cid) {
    disabledInvitationCode.value = true;
    registerFormMoblile.invitationCode = cid;
  } else {
    disabledInvitationCode.value = false;
    registerFormMoblile.invitationCode = "";
  }
};
initInvitationCode();
const registerFormEmail = reactive({
  number: "",
  password: "",
});

const imageCode = reactive({
  url: "",
  isActive: false,
  isError: false,
});

const autoSendMsg = (val: any) => {
  imageCode.isError = false;
  if (registerFormMoblile.inputCode.length == 4) {
    checkRegisterImageCode({
      mobile: registerFormMoblile.number,
      verificationCode: registerFormMoblile.inputCode,
    }).then((res: any) => {
      if (res.code == 0) {
        imageCode.isActive = false;
        imageCode.isError = false;
        sendCode();
      } else {
        imageCode.isActive = true;
        imageCode.isError = true;
      }
    });
  }
};
const sendIphoneCodeFn = () => {
  sendIphoneCode({ mobile: registerFormMoblile.number }).then((res: any) => {
    if (res.code == 0) {
      let data = res.data;
      if (data && data.isVerification == 1) {
        imageCode.url = `data:image/png;base64,${data.image}`;
        imageCode.isActive = true;
      } else {
        imageCode.isActive = false;
        sendCode();
      }
    }
  });
};
//手机注册
const $t = i18n.global.t;
const time = ref(60);
const obtainNumCode = () => {
  if (time.value != 60) {
    return false;
  }
  if (!registerFormMoblile.number) {
    ElMessage.error($t("login.login_email_iphone"));
    return;
  }
  if (language.value === "en" && !isEmail(registerFormMoblile.number)) {
    ElMessage.error($t("login.please_enter_the_account"));
    return;
  }
  if (imageCode.isActive || isEmail(registerFormMoblile.number)) {
    sendCode();
  } else {
    sendIphoneCodeFn();
  }
};
const sendCode = () => {
  let action: any = getSendCode,
    params: any = {
      mobile: registerFormMoblile.number,
      verificationCode: registerFormMoblile.inputCode,
    };
  if (isEmail(registerFormMoblile.number)) {
    action = sendEmailCode;
    params = { email: registerFormMoblile.number };
  }
  action(params).then((res: any) => {
    if (res.code == 0) {
      timer();
    }
  });
};
const timer = () => {
  if (time.value > 0) {
    time.value--;
    sendCodeText.value = time.value + "s";
    setTimeout(timer, 1000);
  } else {
    time.value = 60;
  }
};
const gotoRegister = () => {
  if (!registerFormMoblile.number) {
    ElMessage.error($t("login.login_email_iphone"));
    return;
  }
  if (!registerFormMoblile.password) {
    ElMessage.error($t("login.password_error_text"));
    return;
  }
  if (!registerFormMoblile.iphoneCode) {
    ElMessage.error($t("user_center.code_none"));
    return;
  }
  let action: any = registerIphone,
    params: any = {
      mobile: registerFormMoblile.number,
      password: registerFormMoblile.password,
      smsCode: registerFormMoblile.iphoneCode,
      invitationCode: registerFormMoblile.invitationCode,
      channelNos: registerFormMoblile.channelNos,
    };
  if (isEmail(registerFormMoblile.number)) {
    (action = registerEmail),
      (params = {
        email: registerFormMoblile.number,
        password: registerFormMoblile.password,
        smsCode: registerFormMoblile.iphoneCode,
        invitationCode: registerFormMoblile.invitationCode,
        channelNos: registerFormMoblile.channelNos,
      });
  }
  action(params).then((res: ResultCommon) => {
    if (res.code == 0) {
      ElMessage.success($t("login.reg_success"));
      closeEvent();
      eventLogin();
      registerFormMoblile.number = "";
      registerFormMoblile.iphoneCode = "";
      registerFormMoblile.inputCode = "";
      registerFormMoblile.password = "";
      initInvitationCode();
    }
  });
};
//邮箱注册
const gotoRegisterEmail = () => {
  if (!registerFormEmail.number) {
    ElMessage.error($t("login.please_enter_email_phone"));
    return;
  }
  if (!registerFormEmail.password) {
    ElMessage.error($t("login.password_error_text"));
    return;
  }
  if (!isEmail(registerFormEmail.number)) {
    ElMessage.error($t("login.email_format_error"));
    return;
  }
  registerEmail({
    email: registerFormEmail.number,
    password: registerFormEmail.password,
  }).then((res: any) => {
    if (res.code == 0) {
      let data = res.data;
      confirmEamil();
    }
  });
};
const confirmEamil = () => {
  closeEvent();
};

// 关闭
const closeEvent = () => {
  store.commit("hideRegister");
};
// 去登录
const eventLogin = () => {
  if (isMobile) {
    router.push({
      name: "login",
    });
  } else {
    store.commit("showLogin");
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isShowLogin))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["login", { 'mobile-login': _unref(isMobile) }])
        }, [
          (_unref(isMobile))
            ? (_openBlock(), _createBlock(_component_Logo, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_1, [
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
                  _createElementVNode("li", _hoisted_3, [
                    _createTextVNode(_toDisplayString(_unref($t)("header.signUp")), 1),
                    _hoisted_4
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_el_input, {
                    modelValue: registerFormMoblile.number,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registerFormMoblile.number) = $event)),
                    placeholder: _unref($t)('login.login_email_iphone'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                (imageCode.isActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (!_unref(isMobile))
                        ? (_openBlock(), _createElementBlock("i", _hoisted_11))
                        : _createCommentVNode("", true),
                      _withDirectives(_createElementVNode("div", _hoisted_12, "!", 512), [
                        [_vShow, imageCode.isError]
                      ]),
                      _createVNode(_component_el_input, {
                        modelValue: registerFormMoblile.inputCode,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerFormMoblile.inputCode) = $event)),
                        placeholder: _unref($t)('user_center.please_code'),
                        onInput: autoSendMsg,
                        clearable: "",
                        maxlength: "4",
                        onkeyup: "value=value.replace(/[^\\d]/g,'') "
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("img", {
                        src: imageCode.url,
                        alt: ""
                      }, null, 8, _hoisted_13),
                      _createElementVNode("a", {
                        href: "javascript:;",
                        onClick: sendIphoneCodeFn
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_input, {
                    modelValue: registerFormMoblile.iphoneCode,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerFormMoblile.iphoneCode) = $event)),
                    placeholder: _unref($t)('user_center.please_code'),
                    maxlength: "6",
                    onkeyup: "value=value.replace(/[^\\d]/g,'') "
                  }, null, 8, ["modelValue", "placeholder"]),
                  (time.value === 60)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "send-button",
                        onClick: obtainNumCode
                      }, _toDisplayString(_unref($t)("user_center.send_code")), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(sendCodeText.value), 1))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("form", {
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                  }, [
                    _createVNode(_component_el_input, {
                      modelValue: registerFormMoblile.password,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registerFormMoblile.password) = $event)),
                      type: "password",
                      placeholder: _unref($t)('register.set_register_password'),
                      "show-password": "",
                      onKeyup: _withKeys(gotoRegister, ["enter","native"])
                    }, null, 8, ["modelValue", "placeholder", "onKeyup"])
                  ], 32)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_el_input, {
                    disabled: disabledInvitationCode.value,
                    modelValue: registerFormMoblile.invitationCode,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((registerFormMoblile.invitationCode) = $event)),
                    placeholder: _unref($t)('login.register_channel_code'),
                    clearable: ""
                  }, null, 8, ["disabled", "modelValue", "placeholder"])
                ]),
                _createElementVNode("button", {
                  class: "btn mobile-btn-shadow",
                  onClick: gotoRegister
                }, _toDisplayString(_unref($t)("register.register")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createTextVNode(_toDisplayString(_unref($t)("login.reg_you_agree_to")), 1),
            _createVNode(_component_router_link, {
              target: "_blank",
              to: { path: '/user-privacy' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref($t)("login.user_privacy")), 1)
              ]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_unref($t)("login.and")), 1),
            _createVNode(_component_router_link, {
              target: "_blank",
              to: { path: '/service-clause' }
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_unref($t)("login.terms_of_service1")), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", {
            class: "clause",
            onClick: eventLogin
          }, [
            _createTextVNode(_toDisplayString(_unref($t)("register.login_to")), 1),
            _createElementVNode("span", null, _toDisplayString(_unref($t)("login.login_in")), 1)
          ]),
          (!_unref(isMobile))
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "close",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (closeEvent()))
              }))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    (_unref(store).state.registerDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22))
      : _createCommentVNode("", true)
  ], 64))
}
}

})